export default __webpack_public_path__ + "static/media/image.qfinity-inc-.851034bc.png";